import React, { Fragment, useEffect } from "react";
import { Container } from "react-bs4grid";
import useAppState from "../../../StateMachine/useAppState";

function Logout() {
  const account = useAppState("account");
  const router = useAppState("router");

  useEffect(() => {
    setTimeout(() => {
      account.signout().then(() => {
        router.push("/");
      });
    }, 1000);
  }, []);

  return (
    <Fragment>
      <Container>
        <div className="pt-32">
          <p>please wait ...</p>
        </div>
      </Container>
    </Fragment>
  );
}

export default Logout;
